<div class="max-w-[420px] w-full relative">
  <h5 class="pl-7 pt-7 pb-3 text-lg font-semibold">
    {{ config.title | translate }}
  </h5>

  <form class="px-7" [formGroup]="form" (ngSubmit)="onConfirm()">
    <mat-form-field class="w-full" appearance="outline">
      @if (config.label) {
        <mat-label>{{ config.label | translate }}</mat-label>
      }
      <input matInput formControlName="value" [placeholder]="config.placeholder ?? ''" cdkFocusInitial />
      @if (form.get('value')?.hasError('required')) {
        <mat-error>{{ 'required' | translate }}</mat-error>
      } @else if (form.get('value')?.hasError('pattern')) {
        <mat-error>{{ 'name must not contain slash or backslash' | translate }}</mat-error>
      }
    </mat-form-field>
  </form>

  <div mat-dialog-actions class="mt-2 flex items-center justify-end gap-3" style="border-top: none">
    <button mat-stroked-button (click)="onCancel()" class="rounded-md h-[36px]!">
      {{ (config.cancelText ?? 'cancel') | translate }}
    </button>
    <button mat-flat-button color="primary" (click)="onConfirm()" class="rounded-md h-[36px]!">
      {{ (config.confirmText ?? 'save') | translate }}
    </button>
  </div>
</div>
